var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { ifNotProp, variant } from '@creditas-ui/utilities';
import { styled, css } from '@creditas-ui/system';
import { Box } from '@creditas-ui/layout';
import { Content } from './shared';

var base = _ref => {
  var {
    theme: {
      modal
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-width: 0;\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: 0;\n"])), modal('base.backgroundColor'), modal('base.borderRadius'), modal('base.shadow'));
};

var sizes = _ref2 => {
  var {
    theme: {
      modal
    }
  } = _ref2;
  return variant({
    prop: 'size',
    variants: {
      small: {
        width: "min(".concat(modal('base.size.small'), ", 90vw)")
      },
      medium: {
        width: "min(".concat(modal('base.size.medium'), ", 90vw)")
      },
      large: {
        width: "min(".concat(modal('base.size.large'), ", 90vw)")
      }
    }
  });
};

export var Wrapper = styled(Box.withComponent(Content, process.env.NODE_ENV === "production" ? {
  target: "egbk0np0"
} : {
  target: "egbk0np0",
  label: "Wrapper"
}))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), ifNotProp('resetStyle', base), ifNotProp('resetStyle', sizes));
//# sourceMappingURL=ModalRoot.style.js.map